import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import Content from '../../components/Pages/GeneralSettings';

const { displayName } = config;

export default function GeneralSettings(): React.ReactNode | null {
  document.title = `${displayName}: General settings`;

  return (
    <Layout
      title="General Settings"
    >
      <Content />
    </Layout>
  );
}
